import { useEffect } from 'react';
import { WizardStepBaseProps } from '../../../../wizard/interfaces/wizard-step-base-props';
import { PipelineReview } from '../../../PipelineReview/PipelineReview';
import { useCreatePipelineContext } from '../../hooks/useCreatePipelineContext';

export function CreatePipelineReview({
  controller,
  updateWizardStepFooterProps
}: WizardStepBaseProps) {
  const { pipeline } = useCreatePipelineContext();

  useEffect(() => {
    return () => {
      updateWizardStepFooterProps({});
    };
  }, []);

  return (
    <PipelineReview
      pipeline={pipeline!}
      controller={controller}
      title='Summary'
      onStateUpdate={props => {
        updateWizardStepFooterProps({
          ...props,
          children: 'Save Pipeline'
        });
      }}
      subtitle='Here is the summary of all the existing configurations for this Pipeline.'
      isEditing={false}
    />
  );
}
